module.exports = __webpack_public_path__ + "img/t-6.eaabff31.jpg";